<template>
    <div class="yq-template-select">
        <el-tag v-for="item in selectedItems" :key="item.id" closable @close="deleteItem(item)" effect="plain">
            {{item.name}}
        </el-tag>
        <el-button @click="showDialog" size="mini">选择页面</el-button>
        <el-dialog
                title="选择页面"
                :visible.sync="dialogVisible"
                width="550px" append-to-body>
            <el-form inline size="mini">
                <el-form-item label="页面ID">
                    <el-input v-model="searchModel.id" type="number" style="width: 90px;"></el-input>
                </el-form-item>
                <el-form-item label="页面名称">
                    <el-input v-model="searchModel.nameLike" style="width: 100px"></el-input>
                </el-form-item>
                <el-form-item label="页面类型" v-if="!pageType">
                    <el-select v-model="searchModel.type" clearable multiple style="width: 120px;">
                        <el-option v-for="type in pageTypes" :key="type.type" :value="type.type" :label="type.typeName"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="search">查询</el-button>
                </el-form-item>
            </el-form>
            <div v-if="data">
                <el-table
                        :data="data.content"
                        style="width: 100%"
                        :row-class-name="tableRowClassName">
                    <el-table-column
                            prop="id"
                            label="ID">
                    </el-table-column>
                    <el-table-column
                            prop="name"
                            label="页面名称">
                    </el-table-column>
                    <el-table-column
                            label="页面类型" width="100">
                        <span slot-scope="scope">{{getPageType(scope.row.type).typeName}}</span>
                    </el-table-column>
                    <el-table-column
                            label="操作"
                            width="100">
                        <template slot-scope="scope">
                            <el-button v-if="isSelected(scope.row)" type="text" size="small"
                                       @click="deleteItem(scope.row)">取消选择
                            </el-button>
                            <el-button v-else type="text" size="small"
                                       @click="addItem(scope.row)">选择
                            </el-button>
                        </template>
                    </el-table-column>
                </el-table>
                <el-pagination
                        layout="prev, pager, next" background
                        :total="data.totalElements" :current-page="data.number+1"
                        @current-change="fetchData"
                        style="width: fit-content;margin: 10px auto 0;">
                </el-pagination>
            </div>
            <div slot="footer" style="text-align: center;">
                <el-button type="primary" @click="dialogVisible = false">确认</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
    import pageService from '../../service/page'
    import pageTypeService from '../../service/page-type'

    export default {
        name: "PageSelect",
        props: {
            value: [Object, Array],
            multiple: {
                type: Boolean,
                default: false
            },
            pageType: String
        },
        data() {
            return {
                pageTypes: [],
                searchModel: {
                    id: null,
                    nameLike: null,
                    type: this.pageType
                },
                searchParams: {
                    id: null,
                    nameLike: null,
                    type: this.pageType
                },
                data: null,
                dialogVisible: false
            }
        },
        computed: {
            selectedItems() {
                if (!this.value) {
                    return []
                } else if (Array.isArray(this.value)) {
                    return this.value
                } else {
                    return [this.value]
                }
            }
        },
        created(){
            this.init()
        },
        methods: {
            init(){
                pageTypeService.getAssignedPageTypes().then(pageTypes => this.pageTypes = pageTypes)
            },
            search() {
                this.searchParams = JSON.parse(JSON.stringify(this.searchModel))
                this.fetchData(1)
            },
            fetchData(page) {
                const params = Object.assign({},this.searchParams,{page: page - 1, size: 10})
                pageService.listPages(params).then(response => this.data = response.data)
            },
            deleteItem(row) {
                const newValue = [...this.selectedItems]
                newValue.splice(newValue.findIndex(item => item.id === row.id), 1)
                this.onInput(newValue)
            },
            addItem(row) {
                if (!this.multiple) {
                    this.onInput([row])
                    return
                }
                const newValue = [...this.selectedItems]
                newValue.push(row)
                this.onInput(newValue)
            },
            onInput(items) {
                if (this.multiple) {
                    this.$emit('input', items)
                } else {
                    this.$emit('input', items.length === 0 ? null : items[0])
                }
            },
            isSelected(row) {
                for (const item of this.selectedItems) {
                    if (item.id === row.id) {
                        return true
                    }
                }
                return false
            },
            tableRowClassName({row}) {
                for (const item of this.selectedItems) {
                    if (item.id === row.id) {
                        return 'selected-row'
                    }
                }
                return this.isSelected(row) ? 'selected-row' : ''
            },
            showDialog(){
                if (!this.data) {
                    this.search()
                }
                this.dialogVisible = true
            },
            getPageType(type){
                return pageTypeService.getPageType(type)
            }
        }
    }
</script>
<style scoped>
    .yq-template-select {
        display: inline-block;
    }

    .el-table >>> .selected-row {
        background: #f0f9eb;
    }
    .el-tag{
        margin-right: 5px;
    }
</style>
